import styled from "styled-components"


// interface InputAppProps {
//     readonly primary: boolean;
// }

export const LabelApp = styled.label `

{  
    font-size: 16px;
    color: #133340;
    pointer-event: none;
    transition: all 0.5s ease-in-out;
}




`


